module.exports = __webpack_public_path__ + "img/icon_healthStep_logo.fa5de05f.png";